module.exports = __webpack_public_path__ + "static/media/esflag.edc965f5.png";